export const PRODUCTS_STATS_EVENTS = {
  PRODUCTS_STATS_AMOUNT: 'products-stats-amount',
  PRODUCTS_STATS_COUNT: 'products-stats-count',
  PRODUCTS_STATS_EARNINGS: 'products-stats-earnings',
};

export const PRODUCTS_PRODUCT_FILTER_EVENTS = {
  PRODUCTS_PRODUCT_FILTER_ALL: 'products-filter-product-all',
  PRODUCTS_PRODUCT_FILTER_OSAGO: 'products-filter-product-osago',
  PRODUCTS_PRODUCT_FILTER_GREEN_CARD: 'products-filter-product-green-card',
  PRODUCTS_PRODUCT_FILTER_TOURISM: 'products-filter-product-tourism',
  PRODUCTS_PRODUCT_FILTER_HOME: 'products-filter-product-home',
  PRODUCTS_PRODUCT_FILTER_EXTERNAL: 'products-filter-product-external',
  PRODUCTS_PRODUCT_FILTER_MINI_KASKO: 'products-filter-product-mini-kasko',
  PRODUCTS_PRODUCT_FILTER_PETS: 'products-filter-product-pets',
};

export const PRODUCTS_PARTNER_FILTER_EVENTS = {
  PRODUCTS_PARTNER_FILTER_ALL: 'products-filter-partner-all',
  PRODUCTS_PARTNER_FILTER_MAIN: 'products-filter-partner-main',
};

export const PRODUCTS_PERIOD_FILTER_EVENTS = {
  PRODUCTS_PERIOD_FILTER_CURRENT_MONTH: 'products-filter-period-current-month',
  PRODUCTS_PERIOD_FILTER_MONTH: 'products-filter-period-month',
  PRODUCTS_PERIOD_FILTER_WEEK: 'products-filter-period-week',
  PRODUCTS_PERIOD_FILTER_DAY: 'products-filter-period-day',
  PRODUCTS_PERIOD_FILTER_DATES_RANGE: 'products-filter-period-dates-range',
};
